<script>
    import AudioPlayer from "./AudioPlayer.svelte";
    import EpisodeDesc from "./EpisodeDesc.svelte";
    import EpisodeListing from "./EpisodeListing.svelte";
    import NotFound from "./NotFound.svelte";
    import NavigationBar from "./NavigationBar.svelte";

    import { not_found, static_page } from "../stores/store.js";
    import Page from "./Page.svelte";

    export let episode;
    export let episode_desc;

    const RADIO_STREAM_URL =
        "https://radio.theconspiracyclub.gr/listen/the_conspiracy_club/radio.mp3";

 $: isRadio = $static_page === "radio";
 $: current_media = isRadio ? {
     title: "Το ραδιόφωνο της λέσχης",
     episode: RADIO_STREAM_URL,
     image: "/assets/img/magician.png",
     audiowave: null,
     link: "/radio",
 } : episode;
</script>

<AudioPlayer episode={current_media} {isRadio} />
<NavigationBar />

{#if $not_found}
    <NotFound />
{:else if $static_page && !episode_desc}
    <Page />
{:else}
    {#if episode_desc}
        <EpisodeDesc
            html={episode.description}
            link={episode.link}
            id={episode.id}
            date={episode.publish_date}
        />
    {/if}
    {#if !episode_desc}
        <EpisodeListing />
    {/if}
{/if}
